import { render, staticRenderFns } from "./WordCardList.vue?vue&type=template&id=51f10c69&scoped=true&"
import script from "./WordCardList.vue?vue&type=script&lang=js&"
export * from "./WordCardList.vue?vue&type=script&lang=js&"
import style0 from "./WordCardList.vue?vue&type=style&index=0&id=51f10c69&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f10c69",
  null
  
)

export default component.exports